import { MARK } from "@/constants/customPageSizeMark";
import useAppStore from "@/context/store";
import SearchEmpty from "@/pageComponents/Search/SearchEmpty";
import { getSearchPinsByQingzhou } from "@/services";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import { setSearch } from "@/tracker/shared/global";
import filterUrlParams from "@/utils/filterUrlParams";
import { getPageSize } from "@/utils/getPageSize";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then, When } from "react-if";
import PinList from "../../components/PinList";
import styles from "./index.module.less";
export default function RecallSearch(props) {
  const {
    query,
    haveData,
    splitWords,
    type,
    isAllMatch,
    setIsAllMatch,
    isMaterial,
    dataSource: allMatchData,
  } = props;
  const [hasMore, setHasMore] = useState(true);

  const pageRef = useRef(1);
  const router = useRouter();
  const [dataSource, setDataSource] = useState([]);
  const [masonryKey, setMasonryKey] = useState(false);
  const { q, sort, filterIds } = query;
  const { user } = useAppStore(({ user }) => ({
    user,
  }));
  useEffect(() => {
    // 解决瀑布流容器大小判断，因为需要时间，延迟计算
    const timeout = setTimeout(() => {
      setMasonryKey(!masonryKey);
    }, 400);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  const queryAction = useCallback(async () => {
    // 如果没登陆，且全匹配有数据，则不去触发部分匹配逻辑
    if (haveData && !user) {
      return;
    }

    const filter_ids = filterIds
      ? Object.values(filterUrlParams.decode(filterIds)).reduce(
          (result, value) => {
            result.push(value);
            return result;
          },
          []
        )
      : null;

    const result = await getSearchPinsByQingzhou({
      text: q,
      ...(sort ? { sort } : null),
      ...(filter_ids ? { filter_ids } : null),
      limit: getPageSize(MARK.SEARCHPIN),
      all_match: false,
      material: isMaterial,
      page: pageRef.current,
      position: isMaterial ? "search_material" : "search_pin",
    });
    setSearch({
      search_type: "搜索栏-部分召回",
    });
    const pins = result?.pins || [];
    if (pins.length <= 0) {
      setHasMore(false);
    }
    setDataSource((dataSource) => dataSource.concat(pins));
  }, [filterIds, haveData, isMaterial, q, sort, user]);
  const onLoadMore = useCallback(() => {
    pageRef.current += 1;
    queryAction();
    pvTracker(getPageData());
  }, [queryAction]);
  useEffect(() => {
    queryAction();
  }, []);
  const onChangeKeyword = useCallback(
    (keyWord) => {
      setSearch({
        search_type: "搜索分词-点击",
      });
      const query = {
        q: `${keyWord}`,
        ...(sort ? { sort } : null),
        ...(type ? { type } : null),
        ...(filterIds ? { filter_ids: filterIds } : null),
      };
      router.push({
        page: "/search",
        query: query,
      });
    },
    [filterIds, sort, type, router]
  );
  const newData = useMemo(() => {
    // 过滤掉全匹配里面已出现的数据
    if (allMatchData?.length) {
      let map = {};
      allMatchData.forEach((item) => {
        map[item.pin_id] = true;
      });
      let newData = dataSource.filter((item) => {
        return map[item.pin_id] !== true;
      });
      return newData;
    }
    return dataSource;
  }, [dataSource, allMatchData]);
  const Tip = useMemo(() => {
    return (
      <div className={styles.tips}>
        “<span className={styles.red}>{q}</span>”搜索结果较少，为你找到了
        {splitWords.map((i, index) => {
          return (
            <span key={index}>
              “
              <span
                onClick={() => {
                  onChangeKeyword(i);
                }}
                className={`${styles.red} ${styles.click}`}
              >
                {i}
              </span>
              ”{index !== splitWords.length - 1 && "、"}
            </span>
          );
        })}
        的相关结果：
      </div>
    );
  }, [q, splitWords, onChangeKeyword]);
  return (
    <>
      {/* 如果全匹配有数据则不展示搜索为空组件 */}
      <If condition={haveData}>
        <Then>
          {!!newData?.length && <div className={styles.tipContent}>{Tip}</div>}
        </Then>
        <Else>
          <div style={{ marginTop: "48px" }}>
            {/* 判断部分匹配是否有分词和数据 */}
            {newData?.length ? (
              <SearchEmpty title={Tip} subtitle={null} />
            ) : (
              <SearchEmpty />
            )}
          </div>
        </Else>
      </If>
      <When condition={!!newData?.length}>
        {/* 用来控制pinQueue的值， 控制详情弹窗的下一张取值正确        
            1.如果用户点击全匹配的则pinQueue为全匹配的
            2.如果用户点击部分匹配的则pinQueue的数据为部分匹配
        */}
        <div
          className={styles.recallContent}
          onClick={() => {
            setIsAllMatch(false);
          }}
          data-content-source="部分召回"
        >
          <PinList
            masonryKey={masonryKey}
            dataSource={newData}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
            disableQueue={isAllMatch}
          />
        </div>
      </When>
    </>
  );
}
